import { ChangeDetectionStrategy, Component } from '@angular/core';
import { XmlImportModes } from '@common/knownTypes/XmlImportModes';
import { XmlTypes } from '@common/knownTypes/XmlTypes';
import { DialogRef } from '@progress/kendo-angular-dialog';

@Component({
    selector: 'app-xml-import-confirmation',
    templateUrl: './xml-import-confirmation.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class XmlImportConfirmationComponent {
    xmlType: XmlTypes;
    isTargetEmpty: boolean;
    vesselMismatch: boolean;

    public readonly XmlTypes = XmlTypes;
    public readonly XmlImportModes = XmlImportModes;

    selectedMode: XmlImportModes = XmlImportModes.Replace;

    constructor(public dialog: DialogRef) {}

    confirm() {
        const mode = this.xmlType === XmlTypes.BG415W ? XmlImportModes.Enrich : this.selectedMode;
        this.dialog.close({ xmlType: this.xmlType, importMode: mode });
    }

    cancel() {
        this.dialog.close(null);
    }
}
